<template>
  <div id="main">
    <div id="loading" v-show="oe_off">
      <div id="pcload">
        <div id="oebg" v-show="oe_off"></div>
        <div id="load" v-show="oe_off">
          <div id="jiazai">
            <img src="@/assets/ui/进度条外.png">
            <div id="jiazai_bg" :style="{width:`${0+(load_on*4.09)}px`}"></div>
<!--            <div id="qiu" :style="{marginLeft:`${(load_on)*4.9}px`}">{{ load_on }}%</div>-->
          </div>
        </div>
      </div>
      <div id="phoneload">
        <div id="oebg_m" v-show="oe_off"></div>
        <div id="load_m" v-show="oe_off">
          <div id="jiazai_m">
            <img src="https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E5%8A%A0%E8%BD%BD%E6%9D%A1.png">
            <div id="jiazai_bg_m" :style="{width:`${260-(load_on*2.6)}px`,right:`${6}px`}"></div>
            <div id="qiu_m" :style="{marginLeft:`${(load_on+1.7)*2.4}px`}">{{ load_on }}%</div>
          </div>
        </div>
      </div>
    </div>
    <div id="pc">
      <div id="mainHead">
        <ul class="rightButton">
          <li class="topUi">
            <div :class="{voice: oevoice,voiceClick: !oevoice}" @click="voiceclick"></div>
          </li>
          <li class="topUi">
            <div :class="{visible: oevisible,visibleClick: !oevisible}" @click="visibleclick"></div>
          </li>
          <li class="topUi">
            <div class="rotate" @click="autoRotates"></div>
          </li>
          <li class="topUi">
            <div
                :class="{internationalization: oeinternationalization,internationalizationClick: !oeinternationalization}"
                @click="internationalizationclick"></div>
          </li>
        </ul>
      </div>
      <div id="mainBody">
        <div class="bLeft">
          <div class="leftBox">
            <div class="leftTop">
              <h1 style="color: white;letter-spacing: 2px;text-align:center">{{ oetitle }}</h1>
            </div>
            <div class="leftCenter">
              <div><p style="text-align: left;margin-bottom: 20px;color: white;font-size: 25px;letter-spacing: 2px">
                {{ oeanimation }}</p></div>
              <div class="animation">
                <input type="range" min="1" max="49" class="slider-block" value="1" v-on:input="handleChange"/>
                <!--                <div class="rainbow"></div>-->
                <!--                <div class="drag"></div>-->
              </div>
              <div><p style="text-align: left;margin-bottom: 20px;color: white;font-size: 25px;letter-spacing: 2px">
                {{ oeequipment }}</p></div>
              <div class="eqorch">
                <div class="eqorch1" @click="equipment(0)"
                     :style="{backgroundImage:'url(' + (ea ? oechoreq1 : oechoreqClick1) + ')'}"></div>
                <div class="eqorch2" @click="equipment(1)"
                     :style="{backgroundImage:'url(' + (eb ? oechoreq2 : oechoreqClick2) + ')'}"></div>
                <div class="eqorch3" @click="equipment(2)"
                     :style="{backgroundImage:'url(' + (ec ? oechoreq3 : oechoreqClick3) + ')'}"></div>
              </div>
              <div><p style="text-align: left;margin-bottom: 20px;color: white;font-size: 25px;letter-spacing: 2px">
                {{ oechair }}</p></div>
              <div class="eqorch">
                <div class="eqorch1" @click="chair(0)"
                     :style="{backgroundImage:'url(' + (ca ? oechoreq1 : oechoreqClick1) + ')'}"></div>
                <div class="eqorch2" @click="chair(1)"
                     :style="{backgroundImage:'url(' + (cb ? oechoreq2 : oechoreqClick2) + ')'}"></div>
                <div class="eqorch3" @click="chair(2)"
                     :style="{backgroundImage:'url(' + (cc ? oechoreq3 : oechoreqClick3) + ')'}"></div>
              </div>
              <div><p style="text-align: left;margin-bottom: 20px;color: white;font-size: 25px;letter-spacing: 2px">
                {{ oecolor }}</p></div>
              <div class="eqorch">
                <div class="color1" @click="changeColor(0)"
                     :style="{backgroundImage:'url(' + (coa ? oecolor1 : oecolorClick1) + ')'}"></div>
                <div class="color2" @click="changeColor(1)"
                     :style="{backgroundImage:'url(' + (cob ? oecolor2 : oecolorClick2) + ')'}"></div>
                <div class="color3" @click="changeColor(2)"
                     :style="{backgroundImage:'url(' + (coc ? oecolor3 : oecolorClick3) + ')'}"></div>
              </div>
              <div class="leftBottem">
                <div><a href="https://www.oe3d.cn"><img :src="products" alt="" width="80%"></a></div>
                <div><a href="https://www.vg3dy.com"><img :src="consulting" alt="" width="80%"></a></div>
              </div>
            </div>

          </div>
        </div>
        <div class="bRight">
          <div class="con"></div>
          <div v-show="configure1" class="configure">
            <div class="off" @click="off">X</div>
            <img :src="factory1" alt="">
          </div>
          <div v-show="configure2" class="configure">
            <div class="off" @click="off">X</div>
            <img :src="factory2" alt="">
          </div>
          <div v-show="configure3" class="configure">
            <div class="off" @click="off">X</div>
            <img :src="factory3" alt="">
          </div>
        </div>
      </div>
<!--      <div id="mainFoot"></div>-->
    </div>

    <div id="phone">
      <div id="phoneHead">
        <ul class="mrightButton">
          <li class="mtopUi">
            <div :class="{mvoice: oevoice,mvoiceClick: !oevoice}" @click="voiceclick"></div>
          </li>
          <li class="mtopUi">
            <div :class="{mvisible: oevisible,mvisibleClick: !oevisible}" @click="visibleclick"></div>
          </li>
          <li class="mtopUi">
            <div class="mrotate" @click="autoRotates"></div>
          </li>
          <li class="mtopUi">
            <div
                :class="{minternationalization: oeinternationalization,minternationalizationClick: !oeinternationalization}"
                @click="internationalizationclick"></div>
          </li>
        </ul>
      </div>
      <div id="phoneBody">
        <div class="pLeft">
          <div class="pleftBox">
            <div class="pleftTop">
              <h4 style="color: white;letter-spacing: 2px;text-align:center">{{ oetitle }}</h4>
            </div>
            <div class="pleftCenter">
              <div><p style="text-align: left;margin-bottom: 5px;color: white;font-size: 15px;letter-spacing: 2px">
                {{ oeanimation }}</p></div>
              <div class="manimation">
                <!--                <input type="range" min="1" max="49" class="mslider-block" value="1" v-on:input="handleChange"/>-->

                <div class="mrainbow"></div>
                <div class="mdrag"></div>
              </div>
              <div><p style="text-align: left;margin-bottom: 5px;color: white;font-size: 15px;letter-spacing: 2px">
                {{ oeequipment }}</p></div>
              <div class="meqorch">
                <div class="meqorch1" @click="equipment(0)"
                     :style="{backgroundImage:'url(' + (ea ? oechoreq1 : oechoreqClick1) + ')'}"></div>
                <div class="meqorch2" @click="equipment(1)"
                     :style="{backgroundImage:'url(' + (eb ? oechoreq2 : oechoreqClick2) + ')'}"></div>
                <div class="meqorch3" @click="equipment(2)"
                     :style="{backgroundImage:'url(' + (ec ? oechoreq3 : oechoreqClick3) + ')'}"></div>
              </div>
              <div><p style="text-align: left;margin-bottom: 5px;color: white;font-size: 15px;letter-spacing: 2px">
                {{ oechair }}</p></div>
              <div class="meqorch">
                <div class="meqorch1" @click="chair(0)"
                     :style="{backgroundImage:'url(' + (ca ? oechoreq1 : oechoreqClick1) + ')'}"></div>
                <div class="meqorch2" @click="chair(1)"
                     :style="{backgroundImage:'url(' + (cb ? oechoreq2 : oechoreqClick2) + ')'}"></div>
                <div class="meqorch3" @click="chair(2)"
                     :style="{backgroundImage:'url(' + (cc ? oechoreq3 : oechoreqClick3) + ')'}"></div>
              </div>
              <div><p style="text-align: left;margin-bottom: 5px;color: white;font-size: 15px;letter-spacing: 2px">
                {{ oecolor }}</p></div>
              <div class="meqorch">
                <div class="mcolor1" @click="changeColor(0)"
                     :style="{backgroundImage:'url(' + (coa ? oecolor1 : oecolorClick1) + ')'}"></div>
                <div class="mcolor2" @click="changeColor(1)"
                     :style="{backgroundImage:'url(' + (cob ? oecolor2 : oecolorClick2) + ')'}"></div>
                <div class="mcolor3" @click="changeColor(2)"
                     :style="{backgroundImage:'url(' + (coc ? oecolor3 : oecolorClick3) + ')'}"></div>
              </div>
            </div>
            <div class="pleftBottem">
              <div><a href="https://www.oe3d.cn"><img :src="products" alt="" width="80%"></a></div>
              <div><a href="https://www.vg3dy.com"><img :src="consulting" alt="" width="80%"></a></div>
            </div>
          </div>
        </div>
        <div class="pRight">
          <div v-show="configure1" class="mconfigure">
            <div class="moff" @click="off">X</div>
            <img :src="factory1" alt="">
          </div>
          <div v-show="configure2" class="mconfigure">
            <div class="moff" @click="off">X</div>
            <img :src="factory2" alt="">
          </div>
          <div v-show="configure3" class="mconfigure">
            <div class="moff" @click="off">X</div>
            <img :src="factory3" alt="">
          </div>
          <div class="con1"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mainApp} from "@/assets/app/script/MainApp";
import wx from 'weixin-jsapi'
import axios from 'axios';

let mainapp;
export default {
  name: "AppMain",
  data() {
    return {
      animater: false,
      loader: null,
      load_on: 0,
      oe_off: true,
      time: null,
      autoRotate: true,
      autoRotateOff: false,
      ea: false,
      eb: true,
      ec: true,
      ca: false,
      cb: true,
      cc: true,
      coa: false,
      cob: true,
      coc: true,
      briefIntroduction: false,
      configure1: false,
      configure2: false,
      configure3: false,
      oetitle: "YuanTuo Medical Equipment",
      oeanimation: "Animation",
      oeequipment: "Equipment",
      oechair: "Chair",
      oecolor: "Accessory Color",
      oechoreq1: `${process.env.BASE_URL}ui/英文A款.png`,
      oechoreqClick1: `${process.env.BASE_URL}ui/英文A款选中.png`,
      oechoreq2: `${process.env.BASE_URL}ui/英文B款.png`,
      oechoreqClick2: `${process.env.BASE_URL}ui/英文B款选中.png`,
      oechoreq3: `${process.env.BASE_URL}ui/英文C款.png`,
      oechoreqClick3: `${process.env.BASE_URL}ui/英文C款选中.png`,
      oecolor1: `${process.env.BASE_URL}ui/英文苍翠绿.png`,
      oecolorClick1: `${process.env.BASE_URL}ui/英文苍翠绿选中.png`,
      oecolor2: `${process.env.BASE_URL}ui/英文阳光橙.png`,
      oecolorClick2: `${process.env.BASE_URL}ui/英文阳光橙选中.png`,
      oecolor3: `${process.env.BASE_URL}ui/英文孔雀蓝.png`,
      oecolorClick3: `${process.env.BASE_URL}ui/英文孔雀蓝选中.png`,
      products: `${process.env.BASE_URL}ui/英文其他产品.png`,
      consulting: `${process.env.BASE_URL}ui/英文购买.png`,
      factory1: `${process.env.BASE_URL}ui/英文出厂配置清单1.png`,
      factory2: `${process.env.BASE_URL}ui/英文出厂配置清单2.png`,
      factory3: `${process.env.BASE_URL}ui/英文出厂配置清单3.png`,
      clickMusic: null,
      objectMusic: null,
      oevoice: true,
      oevisible: true,
      oeinternationalization: true,
      oeplay: true,
      offsetX: {
        mouse: 0,
        slider: 0
      },
      canvasShow: true
    }
  },
  beforeDestroy() {
    if (mainapp) {
      mainapp.clean();
      mainapp = null;
      mainapp.clearAnimate();
      console.log("销毁");
    }
  },
  methods: {
    init() {
      let mainContent;
      if (this._isMobile()) {
        mainContent = document.querySelector(".con1");
        let drag = document.querySelector('.mdrag');
        drag.addEventListener("touchstart", this.slider_xuanzhuan_start, {
          passive: false
        });
        drag.addEventListener("touchmove", this.slider_xuanzhuan_move);
        window.addEventListener('touchstart', function () {
            if (self.oeplay) {
              self.objectMusic.play();
              self.oeplay = false;
            }
        });
      } else {
        mainContent = document.querySelector(".con");
        document.addEventListener('click', function () {
          if (self.oeplay) {
            self.objectMusic.play();
            self.oeplay = false;
          }
        });
      }

      mainapp = new mainApp(mainContent);
      let self = this;
    },
    slider_xuanzhuan_start(e) {
      e.preventDefault();

      let x = e.offsetY;
      if (e.touches) { //兼容移动端
        x = e.touches[0].pageY - e.touches[0].target.getBoundingClientRect().top;
        console.log(e.touches[0].target.getBoundingClientRect().top - e.touches[0].target.offsettop, e.touches[0].pageY)
      } else { //兼容PC端
        x = e.offsetY;
        console.log(e.offsetY)
      }
      this.offsetX.slider = x;
    },
    slider_xuanzhuan_move(e) {
      e.preventDefault();
      let sliderbar =document.querySelector(".mrainbow");
      let drag = document.querySelector('.mdrag');
      // if (!isdown.slider) return;
      let x = e.clientY;
      if (!e.touches) { //兼容移动端
        x = e.clientY;
      } else { //兼容PC端
        x = e.touches[0].clientY;
      }
      let sliderBlock_left = this.getPosition(sliderbar).left; //长线条的横坐标
      let minDiv_left = x - sliderBlock_left - this.offsetX.slider; //小方块相对于父元素（长线条）的left值
      if (minDiv_left >= sliderbar.offsetWidth - 10) {
        minDiv_left = sliderbar.offsetWidth - 10;
      }
      if (minDiv_left < 0) {
        minDiv_left = 0;
      }
      //设置拖动后小方块的left值
      drag.style.left = minDiv_left + "px";
      let imgIndex = parseInt((minDiv_left / (sliderbar.offsetWidth - 10)) * 49);
      mainapp.appAutoDisassemble(imgIndex);
      // msg.innerText = imgIndex;
    },
    //获取元素的绝对位置
    getPosition(node) {
      let left = node.offsetLeft; //获取元素相对于其父元素的left值var left
      let top = node.offsetTop;
      let current = node.offsetParent; // 取得元素的offsetParent
      // 一直循环直到根元素
      while (current != null) {
        left += current.offsetLeft;
        top += current.offsetTop;
        current = current.offsetParent;
      }
      return {
        "left": left,
        "top": top
      };
    },
    _isMobile() {
      return navigator.userAgent.match(
          /(phone|pod|iPhone|iPod|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    },
    addmodel() {
      let self = this;
      mainapp.loadModel(`${process.env.BASE_URL}model/YAYI6.glb`, loaded => {
        self.loader = loaded;
        self.loading(loaded);
        mainapp.addHotspot("0");
        mainapp.createHotspot("0", {x: 0, y: 0.4, z: -0.25}, 0.2, () => {
          self.briefIntroduction = true;
          self.configure();
        });
      });
      mainapp.update();
      mainapp.autoRotates(true);
    },
    configure() {
      if (this.briefIntroduction) {
        if (!this.ea) {
          this.configure1 = true;
        } else if (!this.eb) {
          this.configure2 = true;
        } else if (!this.ec) {
          this.configure3 = true;
        }
      }
    },
    off() {
      this.configure1 = false;
      this.configure2 = false;
      this.configure3 = false;
      this.briefIntroduction = false;
    },
    loading(index) {
      let self = this;
      // self.load_on = Number(index*2.777777777777778).toFixed(0);
      self.load_on = index;
      if (index === 100) {
        if (self.time === null) {
          self.time = setTimeout(function () {
            self.oe_off = false;
            clearTimeout(self.time);
          }, 800);
        }
      }
      mainapp.appEquipment("01PJ");
      mainapp.appChair("dengzi01");
    },
    handleChange(event) {
      mainapp.appAutoDisassemble(event.target.value);
    },
    equipment(index) {
      this.playMusic();
      if (index === 0) {
        this.ea = false;
        this.eb = true
        this.ec = true;
        mainapp.appEquipment("01PJ");
      } else if (index === 1) {
        this.ea = true;
        this.eb = false
        this.ec = true;
        mainapp.appEquipment("02PJ");
      } else if (index === 2) {
        this.ea = true;
        this.eb = true
        this.ec = false;
        mainapp.appEquipment("03PJ");
      }
    },
    chair(index) {
      this.playMusic();
      if (index === 0) {
        this.ca = false;
        this.cb = true;
        this.cc = true;
        mainapp.appChair("dengzi01")
      } else if (index === 1) {
        this.ca = true;
        this.cb = false;
        this.cc = true;
        mainapp.appChair("dengzi02")
      } else if (index === 2) {
        this.ca = true;
        this.cb = true;
        this.cc = false;
        mainapp.appChair("dengzi03")
      }
    },
    changeColor(index) {
      this.playMusic();
      if (index === 0) {
        this.coa = false;
        this.cob = true;
        this.coc = true;
        mainapp.appChangeColor('#041C03');
      } else if (index === 1) {
        this.coa = true;
        this.cob = false;
        this.coc = true;
        mainapp.appChangeColor('#8D5218');
      } else if (index === 2) {
        this.coa = true;
        this.cob = true;
        this.coc = false;
        mainapp.appChangeColor('#050F33');
      }
    },
    voiceclick() {
      if (this.oevoice) {
        this.oevoice = false;
        this.objectMusic.pause();
      } else {
        this.playMusic();
        this.objectMusic.play();
        this.oevoice = true;
      }
    },
    visibleclick() {
      if (this.oevisible) {
        this.oevisible = false;
        mainapp.removeHotspot("0");
        this.playMusic();
      } else {
        this.oevisible = true;
        this.playMusic();
        mainapp.addHotspot("0");
        mainapp.createHotspot("0", {x: 0, y: 0.4, z: -0.25}, 0.2, () => {
          this.briefIntroduction = true;
          this.configure();
        });
      }
    },
    internationalizationclick() {
      this.playMusic();
      if (this.oeinternationalization) {
        this.oeinternationalization = false;
        this.oetitle = "原拓医疗机械";
        this.oeanimation = "动画";
        this.oeequipment = "设备";
        this.oechair = "椅子";
        this.oecolor = "配件颜色";
        this.oechoreq1 = `${process.env.BASE_URL}ui/A款.png`;
        this.oechoreqClick1 = `${process.env.BASE_URL}ui/A款选中.png`;
        this.oechoreq2 = `${process.env.BASE_URL}ui/B款.png`;
        this.oechoreqClick2 = `${process.env.BASE_URL}ui/B款选中.png`;
        this.oechoreq3 = `${process.env.BASE_URL}ui/C款.png`;
        this.oechoreqClick3 = `${process.env.BASE_URL}ui/C款选中.png`;
        this.oecolor1 = `${process.env.BASE_URL}ui/苍翠绿.png`;
        this.oecolorClick1 = `${process.env.BASE_URL}ui/苍翠绿选中.png`;
        this.oecolor2 = `${process.env.BASE_URL}ui/阳光橙.png`;
        this.oecolorClick2 = `${process.env.BASE_URL}ui/阳光橙选中.png`;
        this.oecolor3 = `${process.env.BASE_URL}ui/孔雀蓝.png`;
        this.oecolorClick3 = `${process.env.BASE_URL}ui/孔雀蓝选中.png`;
        this.products = `${process.env.BASE_URL}ui/其他产品.png`;
        this.consulting = `${process.env.BASE_URL}ui/咨询.png`;
        this.factory1 = `${process.env.BASE_URL}ui/出厂配置清单1.png`;
        this.factory2 = `${process.env.BASE_URL}ui/出厂配置清单2.png`;
        this.factory3 = `${process.env.BASE_URL}ui/出厂配置清单3.png`;
      } else {
        this.oeinternationalization = true;
        this.oetitle = "YuanTuo Medical Equipment";
        this.oeanimation = "Animation";
        this.oeequipment = "Equipment";
        this.oechair = "Chair";
        this.oecolor = "Accessory Color";
        this.oechoreq1 = `${process.env.BASE_URL}ui/英文A款.png`;
        this.oechoreqClick1 = `${process.env.BASE_URL}ui/英文A款选中.png`;
        this.oechoreq2 = `${process.env.BASE_URL}ui/英文B款.png`;
        this.oechoreqClick2 = `${process.env.BASE_URL}ui/英文B款选中.png`;
        this.oechoreq3 = `${process.env.BASE_URL}ui/英文C款.png`;
        this.oechoreqClick3 = `${process.env.BASE_URL}ui/英文C款选中.png`;
        this.oecolor1 = `${process.env.BASE_URL}ui/英文苍翠绿.png`;
        this.oecolorClick1 = `${process.env.BASE_URL}ui/英文苍翠绿选中.png`;
        this.oecolor2 = `${process.env.BASE_URL}ui/英文阳光橙.png`;
        this.oecolorClick2 = `${process.env.BASE_URL}ui/英文阳光橙选中.png`;
        this.oecolor3 = `${process.env.BASE_URL}ui/英文孔雀蓝.png`;
        this.oecolorClick3 = `${process.env.BASE_URL}ui/英文孔雀蓝选中.png`;
        this.products = `${process.env.BASE_URL}ui/英文其他产品.png`;
        this.consulting = `${process.env.BASE_URL}ui/英文购买.png`;
        this.factory1 = `${process.env.BASE_URL}ui/英文出厂配置清单1.png`;
        this.factory2 = `${process.env.BASE_URL}ui/英文出厂配置清单2.png`;
        this.factory3 = `${process.env.BASE_URL}ui/英文出厂配置清单3.png`;

      }
    },

    /**
     * 自动旋转
     */
    autoRotates() {
      if (this.autoRotate) {
        mainapp.autoRotates(false);
        this.autoRotate = false;
        this.playMusic();
      } else {
        mainapp.autoRotates(true);
        this.autoRotate = true;
        this.playMusic();
      }
    },
    /**
     * 播放动画
     */
    playAnimater() {
      mainapp.playAnimater(1);
    },
    /**
     * 停止动画
     */
    unPlayAnimater() {
      mainapp.playAnimater(0);
    },
    playMusic() {
      if (this.oevoice) {
        this.clickMusic.play();
      }

    },
    createAudio() {
      this.objectMusic = new Audio();
      this.objectMusic.src = `${process.env.BASE_URL}music/beijingyin.mp3`;
      this.objectMusic.loop = true;
      document.body.appendChild(this.objectMusic);
    },
    createAudio2() {
      this.clickMusic = new Audio();
      this.clickMusic.src = `${process.env.BASE_URL}music/点击音效.wav`;
      this.clickMusic.loop = false;
      document.body.appendChild(this.clickMusic);
    },
    share() {
      let self = this;
      axios.post("https://www.vg3dy.com/api/wx/wxShareSignature",
          {url: location.href.split('#')[0]}
      ).then(data => {
        this.res = data.data;
        wx.config({
          debug: false, // 是否开启调试模式
          appId: self.res && self.res.appId, //appid
          timestamp: self.res && self.res.timestamp, // 时间戳
          nonceStr: self.res && self.res.nonceStr, // 随机字符串，只有这个是驼峰?
          signature: self.res && self.res.signature, // 签名
          jsApiList: [
            'onMenuShareAppMessage', 'onMenuShareTimeline'
          ] // 需要使用的JS接口列表
        });

        wx.ready(function () {

          wx.onMenuShareTimeline({
            title: "医疗器材交互展示",
            link: location.href.split('#')[0],
            imgUrl: "https://oe-object.obs.cn-north-4.myhuaweicloud.com/WEB3D/anli/External/officialWebsitePorject/package/yayizonghezhiliaoji/yiliaoqixie.png",
            success: function () {
              //self.weixinoff();
            },
            cancel: function () {
              console.log(222);
              alert(222);
            }
          });
          wx.onMenuShareAppMessage({
            title: "医疗器材交互展示",
            desc: "采用最新的web3D技术，让您的产品更加直观的展示。",
            link: location.href.split('#')[0],
            imgUrl: "https://oe-object.obs.cn-north-4.myhuaweicloud.com/WEB3D/anli/External/officialWebsitePorject/package/yayizonghezhiliaoji/yiliaoqixie.png",
            type: "link",
            dataUrl: "",
            success: function () {
              // self.weixinoff();
            },
            cancel: function () {
              alert("取消")
            }
          });
        });

        wx.error(function (res) {
          alert("错误：" + res);//错误提示
        });
      });
    },
  },
  mounted() {
    this.init();
    this.addmodel();
    this.createAudio();
    this.createAudio2();
    this.share();
  }
}
</script>

<style scoped>


/*#xm_loading{*/
/*  width: 100vw;*/
/*  height: 100vh;*/
/*  background: url("~@/assets/ui/bg.jpg") center center no-repeat;*/
/*  position: absolute;*/
/*  top: 0;*/
/*  z-index: 100;*/
/*}*/
#main {
  width: 100%;
  height: 100%;

}

/*加载页面*/
#loading {
  width: 100%;
  height: 100%;
  position: relative;

}

#pcload {
  display: block;
}

#phoneload {
  display: none;
}

#load {
  background: url("~@/assets/ui/背景.png") center center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  top: 0;
  z-index: 500;
  height: 100%;
  width: 100%;
}

#jiazai {
  width: 409px;
  height: 17px;
  position: absolute;
  z-index: 101;
  top: 70%;
  left: 50%;
  margin-left: -204.5px;
}

#jiazai_bg {
  width: 409px;
  height: 17px;
  background: url("~@/assets/ui/进度条里.png") center center no-repeat;
  position: absolute;
  top: 0;
  left: 0;
  transform: rotate(180deg);
  z-index: 105;
}

#oebg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 120;
  background: #090B3C;
}

/*#qiu {
  width: 42px;
  height: 42px;
  background: url("https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E5%8A%A0%E8%BD%BD%E7%90%83.png") center center no-repeat;
  background-size: 100% 100%;
  position: absolute;
  z-index: 999;
  top: 50%;
  left: 0;
  !*margin-left: 63px;*!
  margin-top: -24px;
  line-height: 42px;
  color: black;
  text-align: center;
  font-size: 1rem;
}*/

/*加载页面*/
#pc {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

#mainHead {
  width: 100%;
  height: 80px;
  color: #fff;
  text-align: center;
  font-family: 微软雅黑;
  line-height: 80px;
}

#mainHead ul {
  width: 290px;
  height: 64.6px;
  position: absolute;
  right: 0;
}

.topUi {
  width: 49.6px;
  height: 49.6px;
  float: left;
  margin-right: 15px;
  margin-top: 15px;
}

.voice {
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/声音.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
  pointer-events: auto;
}

.visible {
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/显示.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
  pointer-events: auto;
}

.rotate {
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/旋转.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
  pointer-events: auto;
}

.internationalization {
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/英文.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
  pointer-events: auto;
}

#mainBody {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  text-align: center;
}

.bLeft {
  width: 900px;
  height: 100%;
  position: relative;

}

.leftBox {
  width: 387px;
  height: 100%;
  margin-left: 120px;
  display: flex;
  flex-direction: column;
  justify-content: left;
}

.leftTop {
  width: 100%;
  height: 100px;
}

.leftCenter {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: left;
}

.leftBottem {
  width: 100%;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  margin-top: 30px;
}

/*滑动条*/
.slider-block {
  outline: none; /*去掉点击时出现的外边框*/
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none; /*这三个是去掉那条线原有的默认样式，划重点！！*/
  width: 100%;
  height: 46px;
  background: url("~@/assets/ui/白条.png") center center no-repeat; /*这三个是设置滑块下面那条线的样式*/
}

input[type="range"]::-webkit-slider-thumb {
  /*::-webkit-slider-thumb是代表给滑块的样式进行变更*/
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none; /*//这三个是去掉滑块原有的默认样式，划重点！！*/
  width: 22px;
  height: 46px;
  background: url("~@/assets/ui/滑块2.png") center center no-repeat;
  cursor: pointer;
  /*background-size: cover;*/ /*//这几个是设置滑块的样式*/
}

/*滑动条*/


.animation {
  width: 100%;
  height: 46px;
  /*background: url("~@/assets/ui/彩虹条.png") center center no-repeat;*/
  position: relative;
  margin-bottom: 20px;
}

.rainbow {
  width: 100%;
  height: 3px;
  background: url("~@/assets/ui/彩虹条.png") center center no-repeat;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  right: -11px;
}

.drag {
  background: url("~@/assets/ui/滑块.png") center no-repeat;
  position: absolute;
  width: 22px;
  height: 46px;
}

.eqorch {
  width: 100%;
  height: 42px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

.eqorch1 {
  background: center no-repeat;
  background-size: 100%;
  width: 119px;
  height: 42px;
  margin-right: 20px;
  cursor: pointer;
  pointer-events: auto;
}

.eqorch2 {
  background: center no-repeat;
  background-size: 100%;
  width: 119px;
  height: 42px;
  margin-right: 20px;
  cursor: pointer;
  pointer-events: auto;
}

.eqorch3 {
  background: center no-repeat;
  background-size: 100%;
  width: 119px;
  height: 42px;
  cursor: pointer;
  pointer-events: auto;
}

.color1 {
  background: center no-repeat;
  background-size: 100%;
  width: 119px;
  height: 42px;
  margin-right: 20px;
  cursor: pointer;
  pointer-events: auto;
}

.color2 {
  background: center no-repeat;
  background-size: 100%;
  width: 119px;
  height: 42px;
  margin-right: 20px;
  cursor: pointer;
  pointer-events: auto;

}

.color3 {
  background: center no-repeat;
  background-size: 100%;
  width: 119px;
  height: 42px;
  cursor: pointer;
  pointer-events: auto;

}


.con {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
}

.configure {
  position: relative;
  z-index: 999;
}

.off {
  position: absolute;
  z-index: 999;
  cursor: pointer;
  pointer-events: auto;
  left: 75%;
  color: white;
}

.bRight {
  width: 100%;
  height: 100%;
  position: relative;
}

#mainFoot {
  width: 100%;
  height: 100px;
}

/*点击后样式*/
.voiceClick {
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/静音.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
  pointer-events: auto;
}

.visibleClick {
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/隐藏.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
  pointer-events: auto;
}

.internationalizationClick {
  width: 100%;
  height: 100%;
  background: url("~@/assets/ui/中文.png") center no-repeat;
  background-size: 100%;
  cursor: pointer;
  pointer-events: auto;
}

/*点击后样式*/
#phone {
  display: none;
}

@media screen and (max-width: 1350px) {
  .off {
    position: absolute;
    z-index: 999;
    cursor: pointer;
    pointer-events: auto;
    left: 83%;
    color: white;
  }
  .configure img{
    width: 60%;
    height: 60%;
  }
}
@media screen and (max-width: 1160px) {
  .off {
    position: absolute;
    z-index: 999;
    cursor: pointer;
    pointer-events: auto;
    left: 88%;
    color: white;
  }
  .configure img{
    width: 70%;
    height: 70%;
  }
}


@media screen and (max-width: 600px) {
  #pc {
    display: none;
  }

  #phone {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  #phoneHead {
    width: 100%;
    height: 100px;
    color: #fff;
    text-align: center;
    font-family: 微软雅黑;
    line-height: 80px;
  }

  #phoneHead ul {
    width: 200px;
    height: 42px;
    position: absolute;
    right: 0;
  }

  .mtopUi {
    width: 27px;
    height: 27px;
    float: left;
    margin-right: 15px;
    margin-top: 15px;
  }

  .mvoice {
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/声音.png") center no-repeat;
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  .mvisible {
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/显示.png") center no-repeat;
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  .mrotate {
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/旋转.png") center no-repeat;
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  .minternationalization {
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/英文.png") center no-repeat;
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  #phoneBody {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    text-align: center;
  }

  .pLeft {
    width: 380px;
    height: 100%;
    position: relative;

  }

  .pleftBox {
    width: 193.5px;
    height: 100%;
    margin-left: 55px;
    display: flex;
    flex-direction: column;
    justify-content: left;
  }

  .pleftTop {
    width: 100%;
    height: 50px;
  }

  .pleftCenter {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: left;
  }

  .pleftBottem {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: left;
  }

  /*滑动条*/
  .mslider-block {
    outline: none; /*去掉点击时出现的外边框*/
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; /*这三个是去掉那条线原有的默认样式，划重点！！*/
    width: 100%;
    height: 23px;
    background: url("~@/assets/ui/白条.png") center center no-repeat; /*这三个是设置滑块下面那条线的样式*/
    background-size: 100%;
    pointer-events: auto;
  }

  input[type=range]:focus {
    outline: none;
  }

  input[type="range"]::-webkit-slider-thumb {
    /*::-webkit-slider-thumb是代表给滑块的样式进行变更*/
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none; /*//这三个是去掉滑块原有的默认样式，划重点！！*/
    width: 11px;
    height: 23px;
    background: url("~@/assets/ui/滑块2.png") center center no-repeat;
    background-size: 100% 100%;
    pointer-events: auto;
    /*background-size: cover;*/ /*//这几个是设置滑块的样式*/
  }

  /*滑动条*/
  .manimation {
    width: 100%;
    height: 23px;
    /*background: url("~@/assets/ui/彩虹条.png") center center no-repeat;*/
    position: relative;
    margin-bottom: 5px;
  }

  .mrainbow {
    width: 100%;
    height: 3px;
    background: url("~@/assets/ui/白条.png") center center no-repeat;
    background-size: 100%;
    position: absolute;
    top: 50%;
    margin-top: -1.5px;
    right: -2px;
  }

  .mdrag {
    background: url("~@/assets/ui/滑块2.png") center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    width: 11px;
    height: 23px;
  }

  .meqorch {
    width: 100%;
    height: 21px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 5px;
  }

  .meqorch1 {
    background: center no-repeat;
    background-size: 100%;
    width: 60px;
    height: 21px;
    margin-right: 20px;
    cursor: pointer;
    pointer-events: auto;
  }

  .meqorch2 {
    background: center no-repeat;
    background-size: 100%;
    width: 60px;
    height: 21px;
    margin-right: 20px;
    cursor: pointer;
    pointer-events: auto;
  }

  .meqorch3 {
    background: center no-repeat;
    background-size: 100%;
    width: 60px;
    height: 21px;
    cursor: pointer;
    pointer-events: auto;
  }

  .mcolor1 {
    background: center no-repeat;
    background-size: 100%;
    width: 60px;
    height: 21px;
    margin-right: 20px;
    cursor: pointer;
    pointer-events: auto;
  }

  .mcolor2 {
    background: center no-repeat;
    background-size: 100%;
    width: 60px;
    height: 21px;
    cursor: pointer;
    margin-right: 20px;
    pointer-events: auto;

  }

  .mcolor3 {
    background: center no-repeat;
    background-size: 100%;
    width: 60px;
    height: 21px;
    cursor: pointer;
    pointer-events: auto;
  }


  .con1 {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }

  .mconfigure {
    position: relative;
    display: inline-block;
    z-index: 999;
  }

  .mconfigure img {
    width: 40%;
    height: 40%;
    z-index: 999;
  }

  .moff {
    position: absolute;
    z-index: 999;
    cursor: pointer;
    pointer-events: auto;
    left: 74%;
    color: white;
  }

  .pRight {
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 9999;
  }

  #phoneFoot {
    width: 100%;
    height: 100px;
  }

  /*点击后样式*/
  .mvoiceClick {
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/静音.png") center no-repeat;
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  .mvisibleClick {
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/隐藏.png") center no-repeat;
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  .minternationalizationClick {
    width: 100%;
    height: 100%;
    background: url("~@/assets/ui/中文.png") center no-repeat;
    background-size: 100%;
    cursor: pointer;
    pointer-events: auto;
  }

  /*加载界面*/
  /*#pcload{
    display: none;
  }
  #phoneload{
    display: block;
  }
  #load_m{
    background: url("https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E6%89%8B%E6%9C%BA%E7%AB%AF%E8%83%8C%E6%99%AF.jpg") center center no-repeat;
    background-size:100% 100%;
    position: absolute;
    top: 0;
    z-index: 100;
    height: 100%;
    width: 100%;
  }

  #jiazai_m{
    width: 270px;
    height: 30px;
    position: absolute;
    z-index: 101;
    top: 70%;
    left: 50%;
    margin-left: -135px;
  }
  #jiazai_m>img{
    width: 100%;
    height: 100%;
  }
  #jiazai_bg_m{
    width: 258px;
    height: 22px;
    !*background: url("~@/assets/UI/加载条_H.png") no-repeat;*!
    !*background-size: 100% 100%;*!
    background-color: black;
    position: absolute;
    top: 9%;
    transform: rotate(180deg);
    border-radius: 11px;
    z-index: 105;
  }
  #qiu_m{
    width: 21px;
    height: 21px;
    background: url("https://jt.vg3dy.com/WEB3D/anli/object/oe3d_anli_ui/UI/%E5%8A%A0%E8%BD%BD%E7%90%83.png") center center no-repeat;
    background-size: 100% 100%;
    position: absolute;
    z-index: 999;
    top: 50%;
    left: 0;
    !*margin-left: 63px;*!
    margin-top:-12px;
    line-height: 21px;
    color: black;
    text-align: center;
    font-size: 0.5rem;
  }
  #oebg_m{
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 80;
    background: #015EC5;
  }
  !*加载界面*!
*/
}

@media screen and (orientation: portrait) {
  html {
    width: 100vmin;
    height: 100vmax;
  }

  body {
    width: 100vmin;
    height: 100vmax;
  }

  #main {
    width: 100vmax;
    height: 100vmin;
    transform-origin: top left;
    transform: rotate(90deg) translate(0, -100vmin);
  }
}

@media screen and (orientation: landscape) {
  html {
    width: 100vmax;
    height: 100vmin;
  }

  body {
    width: 100vmax;
    height: 100vmin;
  }

  #main {
    width: 100vmax;
    height: 100vmin;
  }
}

</style>
